module.exports = __webpack_public_path__ + "static/media/water.9c0985ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/Imgs/water.png
// module id = 68
// module chunks = 0